/** Vết một lần chạy: từng khối, trạng thái, tóm tắt; bấm để xem dữ liệu ra (như n8n). */
import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { ChevronRight } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { LanChay } from '@/lib/automation/run-result'
import { BieuTuongBuoc, KHOI_META } from './khoi-canvas'

export function ChiTietLanChay({ run, onChonKhoi }: { run: LanChay; onChonKhoi?: (nodeId: string) => void }) {
  const { t } = useTranslation('autoCore')
  const [mo, setMo] = useState<number | null>(null)
  if (run.lyDoBoQua) {
    return <p className="rounded-md border bg-muted/30 p-3 text-sm text-muted-foreground"><Trans t={t} i18nKey="detail.skippedHtml" values={{ reason: run.lyDoBoQua }} components={{ b: <b /> }} /></p>
  }
  if (run.steps.length === 0) {
    return <p className="py-6 text-center text-sm text-muted-foreground">{t('detail.noSteps')}</p>
  }
  return (
    <div className="max-h-[70vh] space-y-1.5 overflow-y-auto pr-1">
      {run.steps.map((s, i) => (
        <div key={`${s.nodeId}-${i}`} className="rounded-md border">
          <button type="button" className="flex w-full items-start gap-2 p-2 text-left text-xs hover:bg-accent/40" onClick={() => { setMo(mo === i ? null : i); onChonKhoi?.(s.nodeId) }}>
            <BieuTuongBuoc status={s.status} className="mt-0.5 h-4 w-4 shrink-0" />
            <span className="min-w-0 flex-1">
              <span className="flex flex-wrap items-center gap-1.5">
                <Badge variant="outline" className="px-1.5 py-0 text-[10px]">{KHOI_META[s.kind].nhan}</Badge>
                <span className="font-medium">{s.label}</span>
                {s.branch && <Badge variant={s.branch === 'true' ? 'success' : 'secondary'} className="px-1.5 py-0 text-[10px]">{t('detail.branch', { branch: s.branch === 'true' ? t('detail.branchTrue') : t('detail.branchFalse') })}</Badge>}
              </span>
              <span className="mt-0.5 block whitespace-pre-wrap break-words text-muted-foreground">{s.tomTat}</span>
            </span>
            {(s.output || s.error) && <ChevronRight className={cn('mt-0.5 h-3.5 w-3.5 shrink-0 text-muted-foreground transition-transform', mo === i && 'rotate-90')} />}
          </button>
          {mo === i && (s.output || s.error) && (
            <div className="border-t bg-muted/30 p-2 text-[11px]">
              <p className="mb-1 font-medium text-muted-foreground">{s.error ? t('detail.error') : t('detail.outputData')}</p>
              <pre className="max-h-48 overflow-auto whitespace-pre-wrap break-words rounded bg-background p-2">{s.error ?? JSON.stringify(s.output, null, 2)}</pre>
            </div>
          )}
        </div>
      ))}
      {run.context && (
        <details className="rounded-md border p-2 text-[11px]">
          <summary className="cursor-pointer font-medium text-muted-foreground">{t('detail.context')}</summary>
          <pre className="mt-1 max-h-64 overflow-auto rounded bg-muted/30 p-2">{JSON.stringify(run.context, null, 2)}</pre>
        </details>
      )}
    </div>
  )
}
